import { Box, Link, Stack } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';
import Icon from '@components/Icon/Icon';

import type {
  FileManagementHelpers,
  FileManagementProps,
} from '@hooks/useFileManagement';
import { useFileManagement } from '@hooks/useFileManagement';

import { formatFilename } from '@utils/format';

import type { Attachment as IAttachment } from 'generated/types';

interface AttachmentProps extends Omit<FileManagementProps, 'attachments'> {
  patient_id: string;
  attachment: IAttachment;
  render?: (params: RenderParams) => React.ReactNode;
  filename?: string | null;
}

interface RenderParams extends FileManagementHelpers {
  attachment: IAttachment;
  index: number;
}

const Attachment: React.FC<AttachmentProps> = ({
  patient_id,
  attachment,
  resource,
  render,
  filename: attachmentName,
}) => {
  const fmProps = useFileManagement({
    attachments: [attachment],
    resource,
    patient_id,
  });

  const { operating, handleDownload } = fmProps;

  const filename = attachmentName ?? formatFilename(attachment.title);
  const index = 0;
  return (
    <ContentLoader
      lineCount={1}
      loading={operating[index]}
      style={{ padding: 0 }}
      key={`attachment-${attachment.id}`}
    >
      <Box
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {render ? (
          render({ attachment, index, ...fmProps })
        ) : (
          <Stack direction="row" spacing={2} alignItems="center">
            <Icon color="text.secondary" name="paperclip" type="far" />
            <Link
              aria-label="download"
              onClick={async () => handleDownload(attachment, index)}
              variant="body1"
            >
              {filename}
            </Link>
          </Stack>
        )}
      </Box>
    </ContentLoader>
  );
};

export default Attachment;
